import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Outlet, useLocation } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';
import AdditionalInformation from '@components/Settings/AdditionalInformation/AdditionalInformation';
import MainBackground from '@components/Settings/MainBackground/MainBackground';

import { useAirdropQuery, useExtendedInfoQuery } from '@/api/queries/user';
import AirdropBody from '@/components/Airdrop/AirdropBody/AirdropBody';
import { AppleAccount } from '@/components/Settings/AppleAccount/AppleAccount';
import { DeleteAccount } from '@/components/Settings/DeleteAccount/DeleteAccount';
import { Wallet } from '@/components/Settings/Wallet/Wallet';
import { Tab } from '@/components/Tabs/Tab';
import { Tabs } from '@/components/Tabs/Tabs';
import { TabsNavigation } from '@/components/Tabs/TabsNavigation';

const isNativeApp = Capacitor.isNativePlatform();

const Settings: React.FC = () => {
  const location = useLocation();
  const state = location.state as { activeTab: string } | undefined;
  useAirdropQuery(undefined, { skip: isNativeApp });
  useExtendedInfoQuery();

  const tabs = [
    {
      id: '1',
      label: 'Account',
    },
    {
      id: '2',
      label: 'Overview',
    },
  ];

  return (
    <>
      {location.pathname === '/settings' ? (
        <main>
          <Helmet>
            <title>Settings</title>
          </Helmet>
          <MainBackground />
          <AppleAccount />
          <Tabs initActiveTab={(!isNativeApp && state?.activeTab) || '1'}>
            {/* The native app has no Airdrop overview, so no tabs either */}
            {!isNativeApp && (
              <div className="px-2 mb-4 relative flex gap-2">
                <TabsNavigation list={tabs} indexWithIndicator={undefined} />
              </div>
            )}
            <Tab className="w-full" tabId="1">
              <div
                className="tabs tabs--sticky"
                style={{ padding: '0 0.5rem' }}
              >
                {/* The native app has no USDT balance or withdrawals */}
                {!isNativeApp && <Wallet />}
                <AdditionalInformation />
              </div>
            </Tab>
            {!isNativeApp && (
              <Tab className="w-full" tabId="2">
                <AirdropBody />
              </Tab>
            )}
          </Tabs>
          <DeleteAccount />
          <div className="w-full text-center text-xs opacity-50 py-4">
            v{__APP_VERSION__}
          </div>
        </main>
      ) : (
        <Outlet />
      )}
    </>
  );
};

export default Settings;
